import React, { useEffect, useState } from "react";

export default function Certificate() {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    // Fetch the JSON from public/data/
    fetch(`${process.env.PUBLIC_URL}/data/certificate.json`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load certificates.json");
        return res.json();
      })
      .then(setCertificates)
      .catch((err) => console.error("Error loading certificates:", err));
  }, []);

  // Early loading state
  if (!certificates.length) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-500 text-lg">
        Loading certificates...
      </div>
    );
  }

  // Separate main (trophy wall) and other certificates
  const mainCert = certificates.find((c) => c.type === "main");
  const otherCerts = certificates.filter((c) => c.type !== "main");

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <div className="max-w-6xl mx-auto text-center">
        {/* Title */}
        <h1 className="text-4xl font-bold text-blue-700 mb-8">
          🏆 My Certificates
        </h1>

        {/* Main Trophy Image */}
        {mainCert && (
          <div className="mb-12">
            <img
              src={`${process.env.PUBLIC_URL}${mainCert.image}`}
              alt="Trophy Wall"
              className="mx-auto rounded-2xl shadow-2xl w-full max-w-4xl"
              loading="lazy"
            />
          </div>
        )}

        {/* Grid of Certificates */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
          {otherCerts.map((cert, i) => (
            <div
              key={i}
              className="bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 w-full max-w-sm"
            >
              <img
                src={`${process.env.PUBLIC_URL}${cert.image}`}
                alt={`Certificate ${i + 1}`}
                className="object-contain w-full h-80 md:h-72 lg:h-80"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
